import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { CloudFileListingContext } from "../../../CloudFileListingContext";
import { mapToRejectCloudFileItem } from "./RejectCloudFileItem";
import { RejectMultipleCloudFilesDialog } from "./RejectMultipleCloudFilesDialog";

export const RejectMultipleCloudFilesButton: React.VFC = () => {
    const { selectedItems } = useContext(CloudFileListingContext);

    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton text="Reject" icon="PageRemove" disabled={!selectedItems.length} onClick={onOpen} />
            {isOpen && (
                <RejectMultipleCloudFilesDialog
                    key={String(isOpen)}
                    selectedItems={selectedItems.map(mapToRejectCloudFileItem)}
                    onClose={onClose}
                />
            )}
        </AuthorizationWrapper>
    );
};
